import React, { Component } from 'react';
import Select from 'react-select';
import Text from './text.component';
import propertyTypes from '../json/property-types.json';
import priceValues from '../json/prices-options.json';
import transactionValues from '../json/transactions-options.json';
import '../styles/filters.css';
import TranslationService from '../services/translation.service';
import { AppContext } from '../context';


class Filters extends Component<any> {
  static contextType = AppContext;
  context!: React.ContextType<typeof AppContext>;

  props: any;
  state: any;
  constructor (props: any) {
    super(props);
    this.state = {
      open: false
    };
  }

  render() {
    const { typeIds, setTypeIds, doSearch, transactions, setTransactions, reference, setReference, search, setSearch, priceRanges, setPriceRanges } = this.props;
    var nbFilters = 0;
    if (typeIds && typeIds.length > 0) {
      nbFilters++;
    }
    if (priceRanges && priceRanges.length > 0) {
      nbFilters++;
    }
    if (transactions && transactions.length > 0) {
      nbFilters++;
    }
    if (reference && reference !== '') {
      nbFilters++;
    }
    if (search && search !== '') {
      nbFilters++;
    }

    return <>
      <div className={'filters' + (nbFilters > 0 ? ' active' : '')}>
        <button onClick={() => { this.setState({ open: !this.state.open }); }}
          className={'btn btn-default btn-filters btn-primary' + (this.state.open ? ' open' : '')}>
          {nbFilters > 0 && <span className='number'>{nbFilters}</span>}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23">
            <path d="M14.793 2.27a1.037 1.037 0 0 0-.08.003H1.118C.453 2.318.12 2.74.028 3.16A1.165 1.165 0 0 0 0 3.41a1.066 1.066 0 0 0 .367.808 1.797 1.797 0 0 0 .54.328h14.018c.573 0 .889-.65.95-1.019a.742.742 0 0 0 .01-.117 1.02 1.02 0 0 0-.025-.221c-.102-.46-.508-.919-1.067-.919Zm-3.44 9.203c0 2.003-1.598 3.464-3.41 3.464-1.144 0-2.246-.562-3-1.842a5.389 5.389 0 0 1-.252-.485H.853a1.05 1.05 0 0 1-.33-.147c-.352-.236-.497-.648-.52-.917A.868.868 0 0 1 0 11.473a.73.73 0 0 1 .011-.118c.06-.361.366-.964.842-.964H4.69c.693-1.786 2.132-2.327 3.251-2.327a3.39 3.39 0 0 1 2.16.753 3.416 3.416 0 0 1 1.252 2.656Zm8.903 6.982h3.784a1.067 1.067 0 0 1 .74.486c.132.192.213.416.22.623a.85.85 0 0 1 0 .027c0 .414-.385.945-.828 1.095a.742.742 0 0 1-.238.041h-3.678a4.883 4.883 0 0 1-.537.907C18.946 22.655 17.941 23 17.004 23a3.315 3.315 0 0 1-2.674-1.361 3.447 3.447 0 0 1-.684-2.048c0-1.894 1.546-3.463 3.358-3.463a3.284 3.284 0 0 1 .65.067c1.038.21 2.163.923 2.602 2.26Zm3.83-8.081a.522.522 0 0 0-.099.017h-9.381a.546.546 0 0 0-.036-.008c-.566-.117-.924.772-.924 1.09a.868.868 0 0 0 .003.073c.029.34.255.913.85 1.064h9.595a.594.594 0 0 0 .322-.102c.308-.197.52-.637.572-.917a.659.659 0 0 0 .012-.118.384.384 0 0 0 0-.006c-.005-.31-.382-1.134-.913-1.093ZM11.355 19.59a.846.846 0 0 0 0-.023c-.013-.482-.437-1.06-1.066-1.113H1.013c-.54.045-.89.476-.986.902a1.065 1.065 0 0 0-.027.234.887.887 0 0 0 .013.148c.071.42.43.94 1 .988h9.275a.742.742 0 0 0 .238-.04c.375-.128.708-.527.802-.898a.81.81 0 0 0 .026-.198ZM24.08 5.744A3.414 3.414 0 0 0 25 3.41 3.416 3.416 0 0 0 23.756.76 3.39 3.39 0 0 0 21.589 0C20.043 0 18.71.866 18.23 2.87V3.95a1.198 1.198 0 0 0 .026.238c.195.958 1.45 2.472 2.48 2.522a.694.694 0 0 1 .016 0c.268.007.68.163.837.163a3.455 3.455 0 0 0 2.49-1.13Z"
              fill="rgba(255, 255, 255, 1)"
              fillRule="evenodd" />
          </svg>
        </button>
      </div>
      {this.state.open &&
        <div className='filters-container'>
          <button onClick={() => { this.setState({ open: false }); }} className='close-btn' />
          <div className='title'>
            <Text text={'Filters'} />
          </div>

          <div className='search-field property'>
            <Text text={'Type'} />
            <Select
              value={typeIds}
              isClearable={true}
              isMulti={true}
              isSearchable={false}
              hideSelectedOptions={false}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder={TranslationService.getMessage('All property types', this.context.state.language)}
              onChange={(values) => setTypeIds(values)}
              options={propertyTypes.map((type: any) => {
                return {
                  value: type.value,
                  label: TranslationService.getMessage(type.text, this.context.state.language)
                };
              })} />
          </div>

          <div className='search-field price'>
            <Text text={'Price'} />
            <Select
              value={priceRanges}
              isClearable={true}
              isMulti={true}
              isSearchable={false}
              hideSelectedOptions={false}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder={TranslationService.getMessage('All prices', this.context.state.language)}
              onChange={(values) => setPriceRanges(values)}
              options={priceValues.map((priceValue: any) => {
                return {
                  value: priceValue,
                  label: TranslationService.getMessage(priceValue.text, this.context.state.language)
                };
              })} />
          </div>

          <div className='search-field transaction'>
            <Text text={'Transaction'} />
            <Select
              value={transactions}
              isClearable={true}
              isMulti={true}
              isSearchable={false}
              hideSelectedOptions={false}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder={TranslationService.getMessage('All transactions', this.context.state.language)}
              onChange={(values) => setTransactions(values)}
              options={transactionValues.map((transactionValue: any) => {
                return {
                  value: transactionValue.value,
                  label: TranslationService.getMessage(transactionValue.text, this.context.state.language)
                };
              })} />
          </div>

          <div className='search-field reference'>
            <Text text={'Reference'} />
            <input
              placeholder={TranslationService.getMessage('Reference...', this.context.state.language)}
              type="text"
              value={reference}
              onChange={(e) => setReference(e.currentTarget.value)} />
          </div>

          <div className='search-field text'>
            <Text text={'Textual search'} />
            <input
              placeholder={TranslationService.getMessage('Search...', this.context.state.language)}
              type="text"
              value={search}
              onChange={(e) => setSearch(e.currentTarget.value)} />
          </div>

          <div className='search'>
            <button onClick={() => {
              doSearch();
              this.setState({ open: false});
            }} className='btn btn-default btn-search btn-primary'>
              <Text text={'Apply filters'}/>
            </button>
          </div>
        </div>}
    </>
  }
}
export default Filters;
